module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fnCBQ"))).then(() => module.bundle.root('2KbAe'));